import styled, {DefaultTheme, css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Button} from '@chekinapp/ui';

type FormFieldWrapperProps = {
  $hasError?: boolean;
};

export const FormFieldWrapper = styled.div.attrs({
  className: 'form-field-wrapper kiosko:mb-10 kiosko:w-full',
})<FormFieldWrapperProps>`
  display: inline-block;
  text-align: left;
  margin: 0 auto;
  position: relative;
  width: 275px;

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  [data-variant='airbnb'] > & {
    margin-bottom: 0;
  }

  @media (max-width: ${DEVICE.laptop}) {
    width: 100%;
  }
`;
export const MainButton = styled(Button)`
  margin: 0 auto;
  width: 100%;
  max-width: 295px;

  .buttonLabel {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Box = styled.div`
  width: 309px;
  height: 237px;
  background: ${props => props.theme.colors.branding.boxesModals};
  box-shadow: 0 2px 10px rgba(147, 150, 174, 0.25);
  border-radius: 15px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const PageWrapper = styled.div<{
  $invalidLink?: boolean;
  $isUniversalLink?: boolean;
  $longScrollAreaViewport?: boolean;
}>`
  display: block;
  [data-slot='scroll-area-viewport'] {
    height: 100dvh;
  }

  @media (min-width: ${DEVICE.laptop}) {
    display: grid;
    grid-template-columns: ${props =>
      props.$invalidLink ? 'none' : props.$isUniversalLink ? '352px auto' : '284px auto'};
  }

  @media (min-width: ${DEVICE.laptopM}) {
    display: grid;
    grid-template-columns: ${props =>
      props.$invalidLink ? 'none' : props.$isUniversalLink ? '552px auto' : '284px auto'};
    ${props =>
      props.$invalidLink &&
      css`
        height: 100vh;
      `};
  }
`;

export const RadiosContent = styled.div`
  & .multi-radio {
    gap: 16px;
    margin-bottom: 48px;
  }

  & .multi-radio__option {
    border-radius: 12px;
    border: 1px solid
      ${({theme}) =>
        theme.hasTemplate ? theme.colors.branding.backgroundMain : 'rgba(0, 0, 0, 0.1)'};
    background: ${({theme}) =>
      theme.hasTemplate ? theme.colors.branding.boxesModals : '#fff'};

    padding: 16px;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.07);
    max-width: 327px;
    margin: 0 auto;
    width: 100%;

    & .multi-radio__label {
      color: ${({theme}) => theme.colors.branding.fontPrimary};
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      &:before {
        margin-right: 1em;
      }
    }

    &.multi-radio-option_checked {
      color: ${({theme}) => theme.colors.branding.primary};
      border: 1px solid ${({theme}) => theme.colors.branding.primary ?? '#385bf8'};
    }

    @media (min-width: ${DEVICE.laptop}) {
      max-width: 327px;
      margin: 0 auto;
    }
  }
`;

// eslint-disable-next-line
export const subTitleStyles = ({props, color}: {props?: any; color?: string} = {}) => `
  color: ${color || props.theme.colors.$p10};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
`;

export const regulartTextStyles = ({
  props,
  color,
}: // eslint-disable-next-line
{props?: any; color?: string} = {}) => `
  color: ${color || props.theme.colors.$p10};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
// eslint-disable-next-line
export const titleStyles = ({props}: {props?: any} = {}) => `
  color: ${props.theme.colors.$p10};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  letter-spacing: 1px;
`;

export const getMainColor = (theme: DefaultTheme) => {
  return theme.hasTemplate
    ? theme.colors.branding.icons
    : theme.colors.buttons.mainButtonBackground;
};

export const getBackgroundColor = (
  isEmpty?: boolean,
  isFocused?: boolean,
  theme?: DefaultTheme,
) => {
  if (isEmpty && !isFocused) {
    return theme?.colors?.branding?.backgroundSecondary;
  } else {
    return theme?.colors?.branding?.boxesModals;
  }
};
